import React from 'react';
import { Download } from 'lucide-react';
import { toast } from 'sonner';
import FormationLangagePresentation from '../FormationLangagePresentation';
import FormationLangageQuiz from '../FormationLangageQuiz';

const VeilleProTab = ({ userPurchases, user }) => {
  return (
    <div data-testid="veille-pro-tab">
      <h2 className="heading-2" style={{ marginBottom: '0.5rem' }}>Veille Professionnelle</h2>
      <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>
        Vos formations de veille professionnelle
      </p>
      
      {/* Formation Langage 0-3 ans */}
      {userPurchases.some(p => p.programId === 'veille-pro' && p.kitId === 'formation-langage-0-3' && p.status === 'completed') && (
        <div style={{ marginBottom: '2rem' }}>
          <div className="card" style={{ padding: '1.5rem', marginBottom: '1.5rem', background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', color: 'white' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
              <div>
                <h3 style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.25rem' }}>Développement du langage (0-3 ans)</h3>
                <p style={{ opacity: 0.8, fontSize: '0.9rem' }}>15 modules interactifs</p>
              </div>
              <a
                href="/documents/formations/formation-langage-0-3-ans.pdf"
                download="Formation-Langage-0-3-ans.pdf"
                style={{ background: 'rgba(255,255,255,0.2)', color: 'white', padding: '0.5rem 1rem', borderRadius: '0.5rem', textDecoration: 'none', fontSize: '0.85rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                onClick={(e) => { e.stopPropagation(); toast.success('Téléchargement en cours...'); }}
              >
                <Download size={16} /> PDF
              </a>
            </div>
          </div>
          <FormationLangagePresentation />
          
          {/* Quiz */}
          <div style={{ marginTop: '2.5rem' }}>
            <div style={{ background: 'linear-gradient(135deg, #EEF2FF 0%, #fff 100%)', borderRadius: '1rem', padding: '1.5rem', border: '1px solid #C7D2FE', marginBottom: '1.5rem' }}>
              <h3 style={{ fontWeight: '700', color: '#0f3460', marginBottom: '0.25rem' }}>Quiz de validation</h3>
              <p style={{ color: '#6B7280', fontSize: '0.9rem' }}>10 questions — Obtenez 7/10 minimum pour recevoir votre attestation de réussite</p>
            </div>
            <FormationLangageQuiz userName={user?.name} />
          </div>
        </div>
      )}
    </div>
  );
};

export default VeilleProTab;
